import React from 'react'
import { Steps, Card, Button, Input, Avatar, Typography } from 'antd'
import { CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons'
import type { StepsProps } from 'antd'
import './TextbookReview.css'

const { TextArea } = Input
const { Paragraph } = Typography

const TextbookReview: React.FC = () => {
  const steps: StepsProps['items'] = [
    { title: '编者提交', status: 'finish', icon: <CheckCircleOutlined /> },
    { title: '副主编审核', status: 'process', icon: <ClockCircleOutlined /> },
    { title: '主编审核', status: 'wait' },
    { title: '顾问委员会审稿', status: 'wait' },
  ]

  return (
    <div className="textbook-review-page">
      <Card className="review-header">
        <Steps items={steps} current={1} />
      </Card>

      <div className="review-content">
        <Card title="章节内容" className="content-card">
          {/* 章节内容展示 */}
        </Card>

        <Card title="审核意见" className="review-card">
          <TextArea
            rows={6}
            placeholder="请输入审核意见..."
          />
          <div className="review-actions">
            <Button type="primary">通过</Button>
            <Button>退回修改</Button>
            <Button>添加批注</Button>
          </div>
        </Card>

        <Card title="审核历史" className="history-card">
          <div className="review-history-item">
            <div className="review-history-header">
              <Avatar style={{ backgroundColor: '#C62828' }}>张</Avatar>
              <div className="review-history-info">
                <div className="review-history-author">副主编 张医生</div>
                <div className="review-history-time">2024-01-15 10:30</div>
              </div>
            </div>
            <Paragraph className="review-history-content">
              内容质量良好，建议通过
            </Paragraph>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default TextbookReview

